var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[_c('header',{staticClass:"bar-header"},[_vm._v("学业等级分布")]),_c('div',{staticClass:"bar-echarts",attrs:{"id":"barEcharts"}})])
}]

export { render, staticRenderFns }